import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;

  &&&& {
    border-radius: 10px;
  }

  background-color: ${globals.THEME.bgSurface};
  color: ${globals.textPrimary};
  @media only screen and (max-width: ${globals.tabletBreakpoint}) {
    flex-flow: row wrap;
  }
`;

const containerStyle = `
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 30px;
  flex-shrink: 0;
   @media only screen and (max-width: ${globals.tabletBreakpoint}) {
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  ${containerStyle};

  justify-content: space-between;
  background-color: ${globals.THEME.bgSurfaceSunken};
  color: ${globals.textPrimary};
  width: 350px;
`;

export const SideContainer = styled.div`
  ${containerStyle};

  width: 400px;
  max-width: 100%;
  background-color: ${globals.THEME.bgSurface};
  color: ${globals.textPrimary};
`;

export const PlanOverviewSection = styled.div``;

export const HeaderSection = styled.div`
  margin-bottom: 10px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 140%;
`;

export const Description = styled.div`
  font-size: 14px;
  color: ${globals.THEME.textTertiary};
  line-height: 140%;
`;

export const DescriptionItalic = styled(Description)`
  font-style: italic;
`;

export const CostPerGB = styled.div`
  color: ${globals.THEME.textPrimary};
  font-size: 24px;
  font-weight: 600;
`;

export const Unit = styled.div`
  font-size: 16px;
  color: ${globals.THEME.textTertiary};
  padding-left: 4px;
`;

export const Price = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TotalAmountSection = styled.div`
  display: flex;
  background-color: ${globals.THEME.bgSurface};
  margin-top: 16px;
  margin-bottom: 6px;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${globals.THEME.border};
  border-radius: 4px;
`;

export const DueToday = styled.div`
  color: ${globals.THEME.textPrimary};
  font-weight: 600;
  font-size: 14px;
`;

export const UsageSubscriptionPopup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`;
export const UsageSubscriptionPopupTitle = styled.div`
  display: flex;
  font-family: ${globals.fontName};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 24px;
`;

export const UsageSubscriptionPopupContent = styled.div`
  font-family: ${globals.fontName};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 24px;
`;

export const ConfirmationButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  justify-content: space-between !important;

  .action-button {
    border: none;
    background: ${globals.primary} !important;
    color: white;
    width: unset !important;
    &:hover {
      background: ${globals.THEME.accentHover} !important;
      color: white;
    }
  }

  .contact-button {
    width: unset !important;
    background: ${globals.gray100} !important;
    border: 1px solid ${globals.gray400} !important;
  }
}
`;
